var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBigNotificationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 208.612,
    height: 191.325,
    viewBox: "0 0 208.612 191.325",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bigNotificationIcon",
    transform: "translate(0 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    d: "M35.352,35.351a35.127,35.127,0,0,1-13.76-2.778A35.235,35.235,0,0,1,10.355,25,35.238,35.238,0,0,1,2.779,13.76,35.134,35.134,0,0,1,0,0H70.7a35.132,35.132,0,0,1-2.779,13.76A35.239,35.239,0,0,1,60.349,25a35.237,35.237,0,0,1-11.237,7.576A35.128,35.128,0,0,1,35.352,35.351Z",
    transform: "translate(68.954 151.974)",
    fill: "none",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5144",
    "data-name": "Rectangle 5144",
    d: "M77.369,0h0a77.369,77.369,0,0,1,77.369,77.369v77.8a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0v-77.8A77.369,77.369,0,0,1,77.369,0Z",
    transform: "translate(26.937 0)",
    fill: "none",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_471",
    "data-name": "Line 471",
    x2: 208.612,
    transform: "translate(0 155.172)",
    fill: "var(--bgColor)",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigNotificationIcon);
export default __webpack_public_path__ + "static/media/bigNotificationIcon.86e7c071a5dfa8ed6d66a587f178ff50.svg";
export { ForwardRef as ReactComponent };